import { render, staticRenderFns } from "./AccountBankManage.vue?vue&type=template&id=771fa5ea&scoped=true"
import script from "./AccountBankManage.vue?vue&type=script&lang=js"
export * from "./AccountBankManage.vue?vue&type=script&lang=js"
import style0 from "./AccountBankManage.vue?vue&type=style&index=0&id=771fa5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771fa5ea",
  null
  
)

export default component.exports